import { EnvioDTO } from "./Envio.DTO";
import { obtenerIdTipoMarcador, TipoMarcadorEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";

export interface IMarcadorDTO {
    id: number;
    name: string;
    is_comparative: boolean;
    value: Nilable<string>;
    type: string;
    item: Nilable<number>;
    question: Nilable<number>;
    serie: number;
}

export class MarcadorDTO {
    public id = 0;
    public nombre = "";
    public esComparativa = false;
    public valor: Nilable<string> = null;
    public tipo: TipoMarcadorEnum = TipoMarcadorEnum.AGE_RANGE;
    public itemId: Nilable<number> = null;
    public preguntaId: Nilable<number> = null;
    public envio: EnvioDTO = new EnvioDTO();

    constructor(json: Nilable<Partial<IMarcadorDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<Partial<IMarcadorDTO>>): void {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.is_comparative != null) {
            this.esComparativa = json.is_comparative;
        }
        if (json.value != null) {
            this.valor = json.value;
        }
        if (json.type != null) {
            this.tipo = TipoMarcadorEnum[json.type];
        }
        if (json.item != null) {
            this.itemId = json.item;
        }
        if (json.question != null) {
            this.preguntaId = json.question;
        }
        if (json.serie != null) {
            this.envio = new EnvioDTO({ id: json.serie });
        }
    }

    public toJSON(): IMarcadorDTO {
        return {
            id: this.id,
            name: this.nombre,
            is_comparative: this.esComparativa,
            value: this.valor,
            type: obtenerIdTipoMarcador(this.tipo),
            item: this.itemId,
            question: this.preguntaId,
            serie: this.envio.id
        };
    }
}
